import { useState, useCallback } from "react";
import { employeeService } from "../services/employeeService";

export function usePayroll() {
  const [payrolls, setPayrolls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadPayrolls = useCallback(async (employeeId) => {
    if (!employeeId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await employeeService.getEmployeePayrolls(employeeId);
      setPayrolls(res?.data || []);
    } catch {
      setError("حدث خطأ أثناء جلب سجل المرتبات");
    } finally {
      setLoading(false);
    }
  }, []);

  const addPayroll = async (data, employeeId) => {
    const res = await employeeService.addPayroll(data);
    await loadPayrolls(employeeId);
    return res;
  };

  return { payrolls, loading, error, loadPayrolls, addPayroll };
}